// Import all images at the top
//Images of Featured Dishes
import plin from './assets/images/featured_dishes/PlinPasta.png';
import lobsterbisque from './assets/images/featured_dishes/lobsterPasta.jpg';
import liverpate from './assets/images/featured_dishes/liver.jpg';
import tunatartare from './assets/images/featured_dishes/TunaTartare.png';

//Images of Carousel

import picasso from './assets/images/carousel/Homepage Carousel/online/Picasso1000x750.png';
import picassoFront from './assets/images/carousel/Homepage Carousel/online/PicassoFront1000x750.jpg';

import prosecco from './assets/images/carousel/Homepage Carousel/online/Prosecco1000x667.jpg';


import tablered from './assets/images/carousel/Homepage Carousel/online/TableRed1000,1333.jpg';
import tablesred from './assets/images/carousel/Homepage Carousel/online/TablesRed1000,1333.jpg';

import acquerello from './assets/images/carousel/Homepage Carousel/online/acquerello-bkk.jpg';
import entranceBkk from './assets/images/carousel/Homepage Carousel/online/entrance-bkk.jpg';
import franciacorta from './assets/images/carousel/Homepage Carousel/online/franciacorta-bkk.jpg';
import nomnom from './assets/images/carousel/Homepage Carousel/online/nomnom-bkk.jpg';
import table1 from './assets/images/carousel/Homepage Carousel/online/table1-bkk.jpg';
import winerack from './assets/images/carousel/Homepage Carousel/online/winerack-bkk.jpg';

import foodBkk from './assets/images/carousel/Homepage Carousel/online/food-bkk.jpg';
import guests from './assets/images/carousel/Homepage Carousel/online/guests.jpg';
import profiteroles from './assets/images/carousel/Homepage Carousel/online/profiteroles-bkk.jpg';
import tostada from './assets/images/carousel/Homepage Carousel/online/tostada.jpg';

import rio from './assets/images/people/Chef Rio.png';

// Featured Dishes
const featuredDishes = [
  {
    name: 'Plin Pasta',
    description: `Our Plin Pasta is made with delicate, homemade egg pasta, filled with tender stewed pork and
                  aromatic herbs. Served on a rich onion cream sauce and topped with perfectly seasoned Pecorino
                  cheese, this dish is the ultimate balance of flavors. A personal favorite of Chef Rio—don’t miss out
                  on this culinary masterpiece!`,
    image: plin,  // Adjust image paths if necessary
  },
  {
    name: 'Tagliatelle Lobster Bisque',
    description: `Indulge in our Tagliatelle Lobster Bisque, featuring homemade egg pasta and fresh lobster stewed
                  for hours to create a rich, flavorful bisque. This dish offers the essence of the sea in every bite, with
                  a luxurious depth of flavor. A must-try for anyone looking for an unforgettable pasta experience!`,
    image: lobsterbisque,
  },
  {
    name: 'Liver Pâté',
    description: `Our Liver Pâté is a delicate, melt-in-your-mouth treat. Served on toasted bread and whipped into an
                  airy, fluffy mousse, it’s paired with candied caramelized onions for a sublime contrast of flavors. This
                  dish promises an explosion of taste in every bite—a harmonious blend of richness and sweetness
                  that’s simply irresistible.`,
    image: liverpate,
  },
  // {
  //   name: 'Tuna Tartare',
  //   description: `A personal favorite, our Tuna Tartare features fresh, locally sourced bluefin tuna served on a bed of
  //                 homemade tzatziki and topped with seasoned homemade cheese. Light, refreshing, and bursting
  //                 with flavor, it’s the perfect start to any meal. The combination of the fresh tuna, creamy yogurt, and
  //                 cheese creates a unique and delicious harmony of flavors.`,
  //   image: tunatartare,
  // },
];

export default featuredDishes;

// Homepage Content
const homepageContent = {
  mission: {
    title: 'A Culinary Journey Like No Other',
    text: `Welcome to Sorsi & Morsi, where Italian tradition is the starting point, but never the limit.
              Now in both Pattaya and Bangkok, we invite you to experience Italian cuisine reimagined with global inspiration and a touch of daring creativity.
              Led by internationally renowned Master Chef Rio, our kitchen excels in transforming classic Italian recipes into extraordinary dishes. Expect the familiar flavours of Italy, elevated with inventive techniques and the finest ingredients.
              Every plate at Sorsi & Morsi is made from scratch, in-house, every day, from our handmade pastas to our vibrant sauces and artisan breads. We’re deeply committed to quality, sourcing the best local and imported ingredients to deliver dishes that are as memorable as they are authentic.
              Our menu celebrates both the purity of Italian classics and bold, boundary-pushing mains, always with an eye for detail and a passion for excellence.
              Accessible, unpretentious, and always extraordinary, we believe that remarkable food should be for everyone, not just a privileged few.
              Join us at Sorsi & Morsi in Pattaya or Bangkok for a dining experience where Italian roots and global imagination come together, crafted with care, served with style, and always a cut above the rest.
              Sorsi & Morsi, where tradition meets innovation, and every meal is a journey.`,
  },
};

export { homepageContent };

export const homepageHero = {
  title: 'ITALIAN AT HEART. GLOBAL IN SPIRIT NOW IN PATTAYA & BANGKOK',
  subtitle: 'A signature menu inspired by Italy—reimagined for the world.',
  buttonText: 'BOOK A TABLE',
};

// Carousel Images
export const carouselImages = [
  {
    src: acquerello,
    alt: 'Restaurant Picture',
  },
  {
    src: entranceBkk,
    alt: 'Scallop Dish Picture',
  },
  {
    src: nomnom,
    alt: 'Restaurant Picture',
  },
  {
    src: foodBkk,
    alt: 'Restaurant Picture',
  },
  {
    src: picasso,
    alt: 'Restaurant Picture',
  },
  {
    src: picassoFront,
    alt: 'Restaurant Picture',
  },
  {
    src: franciacorta,
    alt: 'Restaurant Picture',
  },
  {
    src: profiteroles,
    alt: 'Restaurant Picture',
  },
  {
    src: prosecco,
    alt: 'Restaurant Picture',
  },
  {
    src: tablered,
    alt: 'Restaurant Picture',
  },

  {
    src: tablesred,
    alt: 'Restaurant Picture',
  },
  {
    src: guests,
    alt: 'Restaurant Picture',
  },
  {
    src: table1,
    alt: 'Restaurant Picture',
  },
  {
    src: winerack,
    alt: 'Restaurant Picture',
  },
  {
    src: tostada,
    alt: 'Restaurant Picture',
  },
];

//About Us page
export const aboutUs = [
  {
    par1Title: 'Meet Chef Rio',
    par1Text: `Chef Rio’s culinary journey began in the heart of his home kitchen at the young age of 12, where his passion for food was first ignited. 
          By 16, he was already cooking professionally, driven by a relentless curiosity to explore new flavors and techniques. Now, with over 12 years of 
          experience across various types of hospitality businesses, Chef Rio has honed his craft to perfection. A graduate in Culinary and Art Science, 
          Chef Rio has had the privilege of working alongside some of the nation’s top chefs, sharpening his skills and fueling his passion for innovation. 
          An expert in developing new concepts, Chef Rio combines traditional culinary techniques with a modern twist, always aiming to deliver an unforgettable dining experience. 
          With a deep knowledge of diverse cuisines—from Latin American and Japanese to Thai and Mediterranean—Chef Rio’s kitchen is a melting pot of global flavors. 
          Whether it's handcrafted pizzas, artisanal bakery items, or cutting-edge dishes, he is committed to expanding people’s horizons about food. Above all, 
          Chef Rio strives to offer the best value for money, ensuring that every guest at Sorsi & Morsi experiences high-quality, innovative cuisine without the premium price tag. 
          For Chef Rio, food is more than sustenance—it’s an experience, a journey of discovery, and he invites you to join him at Sorsi & Morsi to embark 
          on a culinary adventure like no other.`,
    par1Image: rio,

    par2Title: 'Our Philosophy',
    par2Text: `At Sorsi & Morsi, we believe food should not only be fresh but also a 
                meaningful connection to the local community. That’s why we embrace 
                the zero kilometres philosophy—sourcing nearly all of our ingredients 
                from local farmers and vendors. Every dish is crafted using farm-fresh, 
                never-frozen, and packaging-free products, allowing us to deliver 
                unparalleled quality and flavour while supporting the local economy. 
                Our mission is to break the mold of fine dining by bringing the premium 
                quality of high-end European cuisine to a more accessible, casual dining 
                experience. At Sorsi & Morsi, we are passionate about making every 
                meal an extraordinary journey of flavours—without the premium price 
                tag. Our innovative take on Italian cuisine, led by Master Chef Rio, 
                ensures every bite is a fusion of creativity, authenticity, and excitement.` ,

    par3Title: 'Our Locations',
    par3Text: `Located just 8 minutes from Jomtien Beach in Pattaya, and now at 8 Soi Thonglor, 
                Sukhumvit 55 in the heart of Bangkok, Sorsi & Morsi invites you to discover modern Italian cuisine like never before. 
                Join us for an unforgettable yet approachable dining adventure—now in two cities, and with more to come. `,
  }
]
